export default {
  title: 'Attivazione MAXHUB',
  instruction: 'Inserire correttamente le informazioni utente e venditore che potrebbero influenzare i problemi relativi al servizio post-vendita',
  dealername: 'Nome del rivenditore',
  dealerplaceholder: 'Nome del rivenditore',
  companyname: 'Nome della società',
  companyplaceholder: 'Nome della società',
  tele: 'Informazioni di contatto',
  teleplaceholder: 'Telefono cellulare',
  district: 'Selezione area',
  distplaceholder: 'Informazioni area',
  address: 'Indirizzo dettagliato',
  addrplaceholder: 'Indirizzo dettagliato',
  activebtn: 'Ottieni il codice di attivazione',
  confirmbtn: 'Conferma',
  cancelbtn: 'Cancella',
  dialogmessage: 'Il formato del telefono cellulare è sbagliato, inserire nuovamente',
  dialogbtn: 'Conferma',
  errortitle: 'Impossibile aprire',
  errorinfo1: 'Riprova il controllo della rete',
  errorinfo2: 'Linea assistenza 400-168-9545',
  nosn: 'Questo dispositivo non può essere attivato poiché nessuna SN',
  activepagetitle: 'Codice di attivazione',
  activepagehint: 'Inserire il codice di attivazione per attivare il dispositivo',
  finish: 'Completato',
  search: 'Vicino alla Posizione di Ricerca'
};



// WEBPACK FOOTER //
// ./src/i18n/_it.js